import api from '@/core/api'
import { handleError } from '@/helpers/handleError'
import type { ApiErrorResponse, ApiResponse } from '@/types/apiResponse'

export async function endShift(expected_cash: string): Promise<ApiResponse> {
  try {
    const { data, status: _status } = await api.post(`/wp-json/treesal-shift/v1/shifts/end`, {
      expected_cash
    })

    return {
      success: true,
      data: data.shift.shift
    }
  } catch (error: any) {
    handleError(error)
    return {
      success: false,
      error: error as ApiErrorResponse
    }
  }
}
